import React, { Component } from 'react';
import { GetData } from '../../services/GetData';
import {
	Row,
	Col,
	Button,
	Card,
	CardHeader,
	CardBody,
	Table,
} from 'reactstrap';
import Pagination from "react-js-pagination";
import $ from 'jquery';
import Loader from '../../Loader';
import StudentPage from '../../views/StudentPage';
const GLOBAL = require('../../Globals');
const txtupper = {
	textTransform: 'uppercase',
	fontSize: '20px'
}

const tBorder = { border: '1px solid black', borderCollapse: 'collapse' }

class TransportStudent extends Component {

	/** set property value **/
	constructor(props) {
		super(props);
		this.state = {
			accyear: [],
			acyear: '',
			posts: [],
			postFilter: [],
			modal: false,
			_redirect: false,
			_redirectView: false,
			loading: false,
			currentPage: 1,
			todosPerPage: 20,
			activePage: 1,
			stdname: '',
			stdregno: '',
			filteralert: 1,
			stdmobno: '',
			clas: [],
			cls: '',
			view: '0',
			section: '',
			sections: [],
			routes: [],
			viewtype: 'grid'
		}
		this.basestate = this.state;
		this.handlePageChange = this.handlePageChange.bind(this);
		this.onSearchChange = this.onSearchChange.bind(this);
		this.onClassChange = this.onClassChange.bind(this);
		this.onSecChange = this.onSecChange.bind(this);
		this.onRouteChange = this.onRouteChange.bind(this);
		this.onRegnoSearchChange = this.onRegnoSearchChange.bind(this);
		this.onMobChange = this.onMobChange.bind(this);
		this.onShowChange = this.onShowChange.bind(this);
		this.onChange = this.onChange.bind(this);
		this.printDocument = this.printDocument.bind(this);
	}

	onValChange(e) {
		this.setState({ [e.target.name]: e.target.value });
	}

	toggle() {
		this.setState({
			modal: !this.state.modal
		});
	}

	onChange(e) {

		this.setState({ [e.target.name]: e.target.value });
		this.getclass();
		this.getdata();
		this.setState({ view: '1' });
	}

	onShowChange(e) {
		if (this.state.filteralert == 1) {
			this.state.todosPerPage = e.target.value;
			this.getdata();
			this.setState({ view: '1' });
		}
		else {
			this.state.todosPerPage = e.target.value;
			this.filterdata();
			this.setState({ view: '1' });
		}
	}

	onClassChange(e) {

		this.state.cls = e.target.value;
		if (e.target.value != '') {
			this.getsection();
		}
		this.filterdata();
		this.setState({ view: '1' });
	}

	printDocument() {

		//$("#print-report").show();
		var content = document.getElementById("print-report");
		var pri = document.getElementById("print_frame").contentWindow;
		pri.document.open();
		pri.document.write(content.innerHTML);
		pri.document.close();
		pri.focus();
		pri.print();
	}

	onSecChange(e) {

		this.state.section = e.target.value;
		this.filterdata();
		this.setState({ view: '1' });
	}
	onRouteChange(e) {

		this.state.route = e.target.value;
		this.filterdata();
		this.setState({ view: '1' });
	}

	onSearchChange(e) {

		this.state.stdname = e.target.value;
		this.filterdata();
		this.setState({ view: '1' });
	}

	onRegnoSearchChange(e) {

		this.state.stdregno = e.target.value;
		this.filterdata();
		this.setState({ view: '1' });
	}

	onMobChange(e) {

		this.state.stdmobno = e.target.value;
		this.filterdata();
		this.setState({ view: '1' });
	}

	handlePageChange(pageNumber) {

		this.setState({ activePage: pageNumber });
		this.state.currentPage = Number(pageNumber);
	}

	/** this function will be call when page loading **/
	componentDidMount() {

		this.getacyear();
	}

	/** get Academic Year **/
	getacyear() {
		$("#showLoader").show();
		GetData('academic/getacyear').then((result) => {
			$("#showLoader").hide();
			let responseJson = result;
			if (responseJson) {
				this.setState({
					accyear: responseJson
				});
				var index = responseJson.findIndex(function (obj) {
					return (obj.iscurrent == 1);
				});
				var academic = $("#year").find("option:eq(1)").val();
				this.setState({
					acyear: responseJson[index].id
				});
				$('#year option').eq(index + 1).prop('selected', true).trigger('change');
				this.getdata();
				this.getclass();
				this.getroute();
			}
		});
	}

	getroute() {

		GetData('transport/getroute').then((result) => {
			let responseJson = result;
			if (responseJson) {
				this.setState({
					routes: responseJson
				});
			}
		});
	}

	getsection() {
		var ac = $("#year").val();
		$("#showLoader").show();
		GetData('section/getsecbyclass/' + ac + '/' + this.state.cls).then((result) => {
			$("#showLoader").hide();
			let responseJson = result;
			if (responseJson) {
				this.setState({
					sections: responseJson
				});
			}
		});
	}

	getdata() {
		this.setState({ loading: true });
		this.setState({ posts: [] });
		var ac = $("#year").val();
		$("#showLoader").show();
		GetData('student/gettransportstudent/' + ac).then((result) => {
			$("#showLoader").hide();
			let responseJson = result;
			if (responseJson) {
				this.setState({
					posts: responseJson,
					postFilter: responseJson,
					loading: false
				});
				//$('#show option').eq(1).prop('selected', true).trigger('change');
			}
		});
	}

	/** get Class **/
	getclass() {

		var ac = $("#year").val();
		GetData('classs/getclasbyacyear/' + ac).then((result) => {
			let responseJson = result;
			if (responseJson) {
				this.setState({
					clas: responseJson
				});
			}
		});
	}

	filterdata() {

		this.setState({ filteralert: 2 });
		this.state.postFilter = [];
		var dat = [];
		for (var i = 0; i < this.state.posts.length; i++) {

			if (this.state.stdname != '' && this.state.cls != '' && this.state.section != '') {
				if (this.state.posts[i].stdname.toLowerCase().search(this.state.stdname.toLowerCase()) != -1 && this.state.posts[i].class == this.state.cls && this.state.posts[i].section == this.state.section) {

					dat.push(this.state.posts[i]);
				}
			}
			else if (this.state.stdname != '' && this.state.cls == '' && this.state.section == '') {

				if (this.state.posts[i].stdname.toLowerCase().search(this.state.stdname.toLowerCase()) != -1) {

					dat.push(this.state.posts[i]);
				}
			}
			else if (this.state.stdname == '' && this.state.cls != '' && this.state.section == '') {

				if (this.state.posts[i].class == this.state.cls) {

					dat.push(this.state.posts[i]);
				}
			}
			else if (this.state.cls != '' && this.state.section != '' && this.state.stdname == '') {

				if (this.state.posts[i].class == this.state.cls && this.state.posts[i].section == this.state.section) {

					dat.push(this.state.posts[i]);
				}
			}
			else if (this.state.stdname != '' && this.state.cls != '' && this.state.section == '') {

				if (this.state.posts[i].stdname.toLowerCase().search(this.state.stdname.toLowerCase()) != -1 && this.state.posts[i].class == this.state.cls) {

					dat.push(this.state.posts[i]);
				}
			}
			else if (this.state.stdregno != '') {

				if (this.state.posts[i].regno == this.state.stdregno) {

					dat.push(this.state.posts[i]);
				}
			}

			else if (this.state.stdmobno != '') {

				if (this.state.posts[i].mobile == this.state.stdmobno) {

					dat.push(this.state.posts[i]);
				}
			}
			else if (this.state.route != '') {

				if (this.state.posts[i].route == this.state.route) {

					dat.push(this.state.posts[i]);
				}
			}
		}
		this.setState({ postFilter: dat });
	}

	getimage(gen, url) {

		var photo = '';
		if (url == '') {

			if (gen == 'Male') {
				photo = GLOBAL.BASE_URL + '/public/avatar/boy.png';
			}
			else if (gen == 'Female') {
				photo = GLOBAL.BASE_URL + '/public/avatar/girl.png';
			}
		}
		else {

			photo = url;
		}

		return photo;
	}

	render() {


		$("#print-report").hide();
		var items = this.state.clas;
		var acyear = this.state.accyear;

		/** set showcount select box **/
		this.shows = [
			{ value: '10', name: '10' },
			{ value: '20', name: '20' },
			{ value: '50', name: '50' },
			{ value: '100', name: '100' }
		];

		// Logic for displaying current todos
		const indexOfLastTodo = this.state.currentPage * this.state.todosPerPage;
		const indexOfFirstTodo = indexOfLastTodo - this.state.todosPerPage;
		const currentTodos = this.state.postFilter.slice(indexOfFirstTodo, indexOfLastTodo);

		const renderTodos = currentTodos.map((item, i) => {

			return <tr key={item}>
				<td width="20" className="tablewidth">{i + 1}</td>
				<td width="100">{item.admissionno}</td>
				<td width="300">{item.stdname}</td>
				<td width="150">{item.cls} - {item.sec}</td>
				<td width="100">{item.mobile}</td>
				<td width="200">{item.routename}</td>
				<td width="200">{item.destiname}</td>

			</tr>;
		});

		return (
			<div>
				<StudentPage />
				<div className="animated fadeIn">
					<div className={this.state.alertClass}>
						{this.state._message}
					</div>
					<Row>
						<Col md="12">
							<Card>
								<CardHeader>
									<strong>Transport Student List</strong>&nbsp;&nbsp;
									Academic Year : &nbsp;&nbsp;
									<select name="acyear" onChange={this.onChange} required id="year">
										<option value="">Select</option>
										{
											acyear.map(function (item) {
												return <option value={item.id}>{item.value}</option>;
											})
										}
									</select>&nbsp;&nbsp;
									Reg No : &nbsp;&nbsp;
									<input type="text" name="stdregno" onChange={this.onRegnoSearchChange} />&nbsp;&nbsp;&nbsp;
									Name : &nbsp;&nbsp;
									<input type="text" name="stdname" onChange={this.onSearchChange} />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
									Mobile : &nbsp;&nbsp;
									<input type="text" name="stdmobno" onChange={this.onMobChange} />
									<br />
									<br />
									Class : &nbsp;&nbsp;
									<select name="cls" onChange={this.onClassChange} id="clas">
										<option value="">Select Class</option>
										{
											items.map(function (item) {
												return <option value={item.class}>{item.cls}</option>;
											})
										}
									</select>&nbsp;&nbsp;
									Section : &nbsp;&nbsp;
									<select name="section" onChange={this.onSecChange} id="secs">
										<option value="">Select Section</option>
										{
											this.state.sections.map(function (item) {
												return <option value={item.section}>{item.secs}</option>;
											})
										}
									</select>&nbsp;&nbsp;
									Route : &nbsp;&nbsp;
									<select name="route" onChange={this.onRouteChange} id="route">
										<option value="">Select Route</option>
										{
											this.state.routes.map(function (item) {
												return <option value={item.id}>{item.routecode}</option>;
											})
										}
									</select>&nbsp;&nbsp;
									Total Students : <span>{this.state.postFilter.length}</span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
									show &nbsp;
									<select name="show" onChange={this.onShowChange} id="show" >
										{this.shows.map((e, key) => {
											return <option key={key} value={e.value}>{e.name}</option>;
										})}
									</select>&nbsp;
							   		entries
							<Button size="sm" className="btn-right" color="warning" onClick={this.printDocument}><i className="fa fa-print"></i> Print</Button>
								</CardHeader>
								<CardBody>
									<Table responsive striped id="showdata">
										<thead>
											<tr>
												<th width="20" className="tablewidth">S.No</th>
												<th width="100">Reg No</th>
												<th width="300">Student Name</th>
												<th width="150">Class</th>
												<th width="100">Mobile</th>
												<th width="200">Route</th>
												<th width="200">Destination</th>

											</tr>
										</thead>
										<tbody>
											{this.state.loading ? <tr><td colSpan="8"><center><Loader /></center></td></tr> : renderTodos}
											<br></br>
											<Pagination
												activePage={this.state.activePage}
												itemsCountPerPage={this.state.todosPerPage}
												pageRangeDisplayed={3}
												totalItemsCount={this.state.postFilter.length}
												onChange={this.handlePageChange}
											/>
										</tbody>
									</Table>
								</CardBody>
							</Card>
							<Card>
								<CardBody id="print-report">
									<Row>
										<table id="hide_div" width="100%">
											<tbody>
												<tr>
													<td align="center">
														<img src={GLOBAL.BASE_URL + 'public/sclogo/logo.jpg'} width="60" style={{ position: 'absolute', top: '10px', left: '100px' }} />
														<b style={txtupper}>{GLOBAL.Sclful_NAME}</b><br />
														<b style={{ textTransform: 'uppercase', fontSize: '15px' }}>{GLOBAL.Scl_Addr}</b><br />
													</td>
												</tr>
											</tbody>
										</table>
										<br />
										<Col md="12">
											<table style={tBorder} width="100%">
												<thead>
													<tr>
														<th style={tBorder}>S.No</th>
														<th style={tBorder}>Regno</th>
														<th style={tBorder}>Student Name</th>
														<th style={tBorder}>Class</th>
														<th style={tBorder}>Mobile</th>
														<th style={tBorder}>Route</th>
														<th style={tBorder}>Destination</th>
													</tr>
												</thead>
												<tbody>
													{this.state.postFilter.map((item, index) =>

														<tr key={item}>
															<td style={tBorder}>{index + 1}</td>
															<td style={tBorder}>{item.regno}</td>
															<td style={tBorder}>{item.stdname}</td>
															<td style={tBorder}>{item.cls} - {item.sec}</td>
															<td style={tBorder}>{item.mobile}</td>
															<td style={tBorder}>{item.routename}</td>
															<td style={tBorder}>{item.destiname}</td>
														</tr>
													)}
												</tbody>
											</table>
										</Col>
									</Row>
								</CardBody>
								<iframe name="print_frame" id="print_frame" width="0" height="0" frameborder="0" src="about:blank"></iframe>
							</Card>
						</Col>
					</Row>
				</div>
			</div>
		)
	}
}

export default TransportStudent;


// WEBPACK FOOTER //
// ./src/student/TransportStudent/TransportStudent.js